<div class="banner-wrapper">
  <div class="grid">
    <i class="comment" />
    <span class="sf-600">24/7 Customer Support</span>
    <span class="sf-600"> Need help purchasing your tickets? Our team are available around the clock.</span>
  </div>
  <div class="grid">
    <i class="lock" />
    <span class="sf-600">Secure Checkout Process</span>
    <span class="sf-600">No need to worry - your tickets are guaranteed, no matter what.</span>
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .banner-wrapper {
    display: none;
    @include desktop {
      border: 1px solid #e1e0e0;
      border-radius: 0.3125em;
      display: grid;
      grid-template-columns: 49% 49%;
      gap: 1.88em;
      padding: 1.56em;
      min-height: 11.625em;
    }
    .comment {
      background: url("./comment.svg");
      width: 1.875rem;
      height: 1.875rem;
    }
    .lock {
      background: url("./lock.svg");
      width: 1.42856rem;
      height: 1.875rem;
    }
    div {
      grid-template-columns: 1fr;
      gap: 0.62em;
      span {
        justify-self: center;
        text-align: center;
      }
      i {
        justify-self: center;
        display: inline-block;

        background-size: cover;
        background-repeat: no-repeat;
      }
    }
  }
</style>
